import MagResignation from 'containers/Warehouse/resignation/Termination'
import { selectWarehouse } from 'containers/Warehouses/warehousesSlice'
import RentalExtension from 'containers/Warehouse/RentalExtension'
import MagCancel from 'containers/Warehouse/resignation/Cancel'
import useWarehousesLoading from 'hooks/useWarehousesLoading'
import MagDetails from 'containers/Warehouse/MagDetails'
import { useHistory, useParams } from 'react-router-dom'
import MagActions from 'containers/Warehouse/MagActions'
import MagHistory from 'containers/Warehouse/MagHistory'
import MagAccess from 'containers/Warehouse/MagAccess'
import MagStatus from 'containers/Warehouse/MagStatus'
import { SECTION_TYPES } from 'containers/Warehouse'
import Invoices from 'containers/Account/Invoices'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import Warehouse from 'components/Warehouse'
import MagNumber from 'components/MagNumber'
import { useReduxSelector } from 'store'
import './style.scss'

const SubMenu = () => {
  const { id, type } = useParams()
  const { name, contractId, placeAddress, typeName } = useReduxSelector(state => selectWarehouse(state, id))

  useWarehousesLoading(!contractId)
  const { goBack } = useHistory()
  const { t } = useTranslation('warehouse')

  return (
    <div className='desktopWarehouse'>
      <div className='title --withBtn'>
        <div>{typeName}</div>
        <div className='group'>
          <span>{placeAddress}</span>
        </div>
        <ArrowBtn
          text={t('back')}
          action={goBack}
          className='--reverse --black'
        />
      </div>
      <div className="desktopWarehouse__wrap">
        <div className="desktopWarehouse__sidebar">
          <MagNumber number={name} />
          <Warehouse />
          <MagStatus isDesktop />
          <MagActions
            id={id}
            expanded={true}
            toggleMenu={false} />
        </div>
        <div className="desktopWarehouse__content">
          {(() => {
            switch (type) {
              case SECTION_TYPES.invoices: return <div className='account menu__section'>
                <Invoices onlyBody />
              </div>
              case SECTION_TYPES.history: return <MagHistory id={id} full />
              case SECTION_TYPES.details: return <MagDetails />
              case SECTION_TYPES.termination: return <MagResignation />
              case SECTION_TYPES.extension: return <RentalExtension />
              case SECTION_TYPES.cancel: return <MagCancel />
              default: return <MagAccess full />
            }
          })()}
        </div>
      </div>
    </div>
  )
}

export default SubMenu